module.exports = __webpack_public_path__ + "static/media/amulet-rare.eda548f2.png";